import LoginLayout from './Login.jsx';

export {LoginLayout};



// WEBPACK FOOTER //
// ./components/layouts/login/index.js